import styled from 'styled-components';

import Image from 'components/atom/Image';

export const Container = styled(Image)`
  width: clamp(2.125rem, 70vw, 6rem);
`;

export const Slogan = styled.p`
  color: white;
  margin-top: 0.5rem;
`;
